import classNames from 'classnames'
import { useStableId } from '../../utils'
import { Tooltip } from '../tooltip'
import styles from './PointBadge.module.css'

export type BadgeVariant = 'SUCCESS' | 'WARNING' | 'DANGER' | 'NEUTRAL' | 'LIGHT' | 'DARK' | 'BLUE'

interface Props {
  variant: BadgeVariant
  className?: string
  tooltipText?: string
}

export const PointBadge = (props: Props) => {
  const stableId = useStableId()
  const id = stableId + '-badge'
  const PointBadge = <div id={id} className={classNames(styles.badge, styles[props.variant], props.className)} />

  return props.tooltipText ? (
    <Tooltip referenceId={id} label={props.tooltipText}>
      {PointBadge}
    </Tooltip>
  ) : (
    PointBadge
  )
}
